import { render, staticRenderFns } from "./EditHouseType.vue?vue&type=template&id=58bd2c91&scoped=true"
import script from "./EditHouseType.vue?vue&type=script&lang=js"
export * from "./EditHouseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd2c91",
  null
  
)

export default component.exports